// 9fbef606107a605d69c0edbcd8029e5d
import { defaultMemoize } from 'reselect';
/**
 * @param {object[]} productBlocks
 * @returns {object[]}
 * @description This function filters out the object with products from horizontalPlpProducts
 * @module Horizontalcategory
 */
export const formatHlpProducts = (productBlocks, parentCategory) => {
  if (Array.isArray(productBlocks[parentCategory]) && productBlocks[parentCategory].length > 0) {
    return productBlocks[parentCategory].filter(
      (block) => typeof block.numberOfProducts !== 'undefined'
    );
  }
  return [];
};

const compareSetVal = (navObj, setKey, expectedVal) => {
  return (
    navObj?.categoryContent?.mainCategory?.set?.filter(
      (setEntry) => setEntry.key === setKey && setEntry.val
    )[0]?.val === expectedVal
  );
};

export const findL1CategoryObject = defaultMemoize((navObj, catId) => {
  return navObj.find((nav) => nav.categoryId === catId);
});

export const getL2Siblings = defaultMemoize((catObj, catId) => {
  const parentCatName = catObj?.categoryContent?.name || '';
  if (!catObj?.categoryContent?.mainCategory) {
    return [];
  }
  const shouldHideCarousel = compareSetVal(catObj, 'hideCarousel', 'true');
  if (shouldHideCarousel) {
    return [];
  }
  const groupKeys = Object.keys(catObj?.subCategories || {})?.sort() || [];
  let siblings = [];

  let shouldCollectSiblings = true;
  groupKeys.forEach((key) => {
    if (shouldCollectSiblings) {
      siblings = catObj?.subCategories?.[key]?.items;
    }
    if (siblings.findIndex((sib) => sib?.categoryContent?.catgroupId === catId) > -1) {
      shouldCollectSiblings = false;
    }
  });
  if (!shouldCollectSiblings && siblings.length > 0) {
    return siblings
      ?.filter((sib) => sib?.categoryContent?.displayToCustomer === true)
      ?.map((sibling) => {
        const filterTitle = sibling?.categoryContent?.name;
        return {
          categoryId: sibling?.categoryContent?.catgroupId,
          title: `${parentCatName} > ${filterTitle}`,
          alt: `${parentCatName} > ${filterTitle}`,
          filterTitle,
          linkAspath: sibling.asPath,
          asPath: sibling.asPath,
          linkUrl: sibling.url,
          url: sibling?.categoryContent?.mainCategory?.categoryFilterImage?.[0]?.url || '',
        };
      });
  }
  return [];
});

export const getL2SiblingsData = defaultMemoize((navigationData, l1CatId, l2CatId) => {
  const l1CategoryObj = findL1CategoryObject(navigationData, l1CatId);
  return getL2Siblings({ ...l1CategoryObj }, l2CatId);
});
